import src from "./logo-sm.svg"

const width = 76
const height = 30
export default { src, width, height }
